import React from 'react'
import Eula from '../eula'

const EulaPt = () => {
    return <Eula languageCode="pt" />
}

export default EulaPt
